import { ReactNode } from "react";

export const ONBOARDING_STEP = {
  ENTITY_TYPE: 1,
  PERSONAL_DETAILS: 2,
  PHONE: 3,
  CONFIRM_ENTITY: 4,
  REVIEW_ENTITY: 5,
} as const;

export type StepId = (typeof ONBOARDING_STEP)[keyof typeof ONBOARDING_STEP];

export const STEP_STATUS = {
  LOCKED: "locked",
  ACTIVE: "active",
  DONE: "done",
} as const;

export type StepStatus = (typeof STEP_STATUS)[keyof typeof STEP_STATUS];

export type BadgeKind = "mandatory" | "recommended" | "optional";

export type StepConfig = {
  id: StepId;
  title: string;
  subtitle: string;
  badge: BadgeKind;
};

export const STEP_CONFIG: StepConfig[] = [
  {
    id: ONBOARDING_STEP.ENTITY_TYPE,
    title: "Before we set up your account",
    subtitle:
      "Tell us about your business entity so we can make sure Inkle is the right fit for you",
    badge: "mandatory",
  },
  {
    id: ONBOARDING_STEP.PERSONAL_DETAILS,
    title: "Your details",
    subtitle: "Your full legal name and work email",
    badge: "mandatory",
  },
  {
    id: ONBOARDING_STEP.PHONE,
    title: "Phone verification",
    subtitle: "Verify your phone number",
    badge: "mandatory",
  },
  {
    id: ONBOARDING_STEP.CONFIRM_ENTITY,
    title: "Confirm your brand details",
    subtitle: "Confirm these details so we can find your entity records",
    badge: "mandatory",
  },
  {
    id: ONBOARDING_STEP.REVIEW_ENTITY,
    title: "Complete your entity details",
    subtitle: "Entity information of all the U.S. entities",
    badge: "mandatory",
  },
];

export const INVITED_STEP_CONFIG: StepConfig[] = [
  {
    id: ONBOARDING_STEP.PERSONAL_DETAILS,
    title: "Your details",
    subtitle: "Confirm your full legal name",
    badge: "mandatory",
  },
  {
    id: ONBOARDING_STEP.PHONE,
    title: "Phone verification",
    subtitle: "Verify your phone number",
    badge: "mandatory",
  },
];

export type StepSummary = ReactNode;
